import React from "react";
import { Linkedin, Mail } from "lucide-react";

const team = [
  {
    initials: "AA",
    name: "Ahmed Ali",
    role: "Director & Lead Accountant",
    creds: "MAAT, BA",
    bio: "Founded Xab Accountants to bring proper, modern accounting to the businesses big firms ignore. Specialises in limited company tax planning and growth advisory.",
  },
  {
    initials: "NW",
    name: "Newton Wafula",
    role: "Senior Accountant",
    creds: "CPA",
    bio: "Heads up bookkeeping, VAT and payroll. Will probably catch the £400 expense you forgot to claim — and remind you why MTD matters.",
  },
];

export const Team = () => (
  <section
    data-testid="team-section"
    className="bg-white py-20 md:py-28"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C57A5A] font-medium">
          Meet the team
        </p>
        <h2 className="font-serif-display mt-3 text-3xl sm:text-4xl md:text-5xl text-[#2A3430] leading-tight">
          Real accountants. Real qualifications.
        </h2>
      </div>

      <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
        {team.map((m) => (
          <div
            key={m.name}
            data-testid={`team-card-${m.initials.toLowerCase()}`}
            className="group bg-[#EAF4DD] border border-[#2A3430]/10 rounded-3xl p-8 md:p-10 flex flex-col sm:flex-row gap-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#C57A5A]/10 hover:border-[#C57A5A]/40"
          >
            <div className="shrink-0">
              <div className="relative h-24 w-24 rounded-3xl bg-[#2A3430] grid place-items-center text-white font-serif-display text-3xl shadow-lg shadow-[#2A3430]/30 ring-4 ring-white">
                {m.initials}
                <span className="absolute -bottom-1 -right-1 h-5 w-5 rounded-full bg-[#C57A5A] ring-4 ring-[#EAF4DD]" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-serif-display text-2xl text-[#2A3430]">{m.name}</h3>
              <p className="text-sm text-[#C57A5A] font-medium mt-0.5">
                {m.role}
              </p>
              <p className="text-xs uppercase tracking-widest text-[#2A3430]/60 mt-1">
                {m.creds}
              </p>
              <p className="mt-4 text-sm text-[#2A3430]/85 leading-relaxed">
                {m.bio}
              </p>
              <div className="mt-5 flex items-center gap-2">
                <a
                  href="#contact"
                  data-testid={`team-${m.initials.toLowerCase()}-email`}
                  className="inline-flex items-center gap-1.5 text-xs text-[#2A3430] hover:text-[#C57A5A] transition rounded-full px-3 py-1.5 bg-white border border-[#2A3430]/10"
                >
                  <Mail className="h-3.5 w-3.5" /> Get in touch
                </a>
                <a
                  href="#contact"
                  data-testid={`team-${m.initials.toLowerCase()}-linkedin`}
                  className="inline-flex items-center gap-1.5 text-xs text-[#2A3430] hover:text-[#C57A5A] transition rounded-full px-3 py-1.5 bg-white border border-[#2A3430]/10"
                >
                  <Linkedin className="h-3.5 w-3.5" /> LinkedIn
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
